import { Link } from 'react-router-dom';
import { BrandLogo } from '@/components/BrandLogo';
import { Phone, Mail } from 'lucide-react';

const SENATUR_LOGO = '/logos/gobierno-senatur.png';
const VISIT_PARAGUAY_LOGO = '/logos/gobierno-visit-paraguay.png';
const REGISTUR_BADGE = '/logos/registur.png';

export function LandingFooter({ brandData, t }) {
  return (
    <footer className="bg-[#1C1917] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="col-span-2">
            <Link to="/" className="inline-block mb-4" aria-label={brandData?.site_name || 'Estadía 365'}>
              <BrandLogo onDark className="h-28 w-auto" alt={brandData?.site_name || 'Estadía 365'} />
            </Link>
            <p className="text-[#78716C] max-w-sm">
              {brandData?.footer_text || t('landing.footer.desc')}
            </p>

            {/* Official logos */}
            <div className="mt-6">
              <p className="text-xs text-[#57534E] mb-3 uppercase tracking-wider">Registrado ante</p>
              <div className="flex items-center gap-4 flex-wrap">
                <a
                  href="https://senatur.gov.py/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Secretaría Nacional de Turismo Paraguay"
                  data-testid="senatur-logo-link"
                >
                  <img
                    src={SENATUR_LOGO}
                    alt="SENATUR - Secretaría Nacional de Turismo Paraguay"
                    className="logo-plate h-12 w-auto object-contain"
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://registur.gov.py/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="REGISTUR - Visit Paraguay"
                  data-testid="registur-logo-link"
                >
                  <img
                    src={VISIT_PARAGUAY_LOGO}
                    alt="Visit Paraguay - REGISTUR"
                    className="logo-plate h-12 w-auto object-contain"
                    loading="lazy"
                  />
                </a>
              </div>
              {/* REGISTUR Certificate */}
              <div className="mt-4">
                <a
                  href="https://registur.gov.py/establecimientos/2309"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Ver certificado REGISTUR de ESTADIA 365"
                  data-testid="registur-certificate-link"
                >
                  <img
                    src={REGISTUR_BADGE}
                    alt="Certificado REGISTUR vigente de ESTADIA 365"
                    className="logo-plate h-12 w-auto object-contain"
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4" style={{ fontFamily: 'var(--font-heading, Outfit)' }}>{t('landing.footer.links')}</h4>
            <ul className="space-y-2">
              <li><Link to="/properties" className="text-[#78716C] hover:text-white transition-colors">{t('landing.footer.accommodations')}</Link></li>
              <li><Link to="/map" className="text-[#78716C] hover:text-white transition-colors">{t('landing.footer.destinations')}</Link></li>
              <li><Link to="/about" className="text-[#78716C] hover:text-white transition-colors">{t('landing.footer.aboutUs')}</Link></li>
              <li><Link to="/publicaciónes" className="text-[#78716C] hover:text-white transition-colors">{t('landing.footer.posts')}</Link></li>
              <li><Link to="/sumar-alojamiento" className="text-[#78716C] hover:text-white transition-colors">{t('landing.footer.addProperty')}</Link></li>
              <li>
                {brandData?.contact?.email ? (
                  <a href={`mailto:${brandData.contact.email}`} className="text-[#78716C] hover:text-white transition-colors">{t('landing.footer.contact')}</a>
                ) : (
                  <Link to="/faq" className="text-[#78716C] hover:text-white transition-colors">{t('landing.footer.contact')}</Link>
                )}
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4" style={{ fontFamily: 'var(--font-heading, Outfit)' }}>{t('landing.footer.legal')}</h4>
            <ul className="space-y-2">
              <li><Link to="/terms" className="text-[#78716C] hover:text-white transition-colors">{t('landing.footer.termsConditions')}</Link></li>
              <li><Link to="/terms" className="text-[#78716C] hover:text-white transition-colors">{t('landing.footer.privacyPolicy')}</Link></li>
            </ul>
            <h4 className="font-semibold text-white mt-6 mb-4" style={{ fontFamily: 'var(--font-heading, Outfit)' }}>{t('landing.footer.contact')}</h4>
            <ul className="space-y-3">
              {brandData?.contact?.phone && (
                <li className="flex items-center gap-2 text-[#78716C]">
                  <Phone className="w-4 h-4" style={{ color: 'var(--brand-secondary, #C36F4D)' }} />
                  <a href={`tel:${brandData.contact.phone}`} className="hover:text-white transition-colors">{brandData.contact.phone}</a>
                </li>
              )}
              {brandData?.contact?.email && (
                <li className="flex items-center gap-2 text-[#78716C]">
                  <Mail className="w-4 h-4" style={{ color: 'var(--brand-secondary, #C36F4D)' }} />
                  <a href={`mailto:${brandData.contact.email}`} className="hover:text-white transition-colors">{brandData.contact.email}</a>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="border-t border-[#333] mt-12 pt-8 text-center">
          <p className="text-[#78716C] text-sm">
            © {new Date().getFullYear()} {brandData?.site_name || 'Estadía 365'}. {t('landing.footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}
